/*!
 * devextreme-angular
 * Version: 24.2.5
 * Build date: Fri Feb 14 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import { PositionConfig } from 'devextreme/common/core/animation';

import {
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-menu-from',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoMenuFromComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get left(): number {
        return this._getOption('left');
    }
    set left(value: number) {
        this._setOption('left', value);
    }

    @Input()
    get opacity(): number {
        return this._getOption('opacity');
    }
    set opacity(value: number) {
        this._setOption('opacity', value);
    }

    @Input()
    get position(): PositionConfig {
        return this._getOption('position');
    }
    set position(value: PositionConfig) {
        this._setOption('position', value);
    }

    @Input()
    get scale(): number {
        return this._getOption('scale');
    }
    set scale(value: number) {
        this._setOption('scale', value);
    }

    @Input()
    get top(): number {
        return this._getOption('top');
    }
    set top(value: number) {
        this._setOption('top', value);
    }


    protected get _optionPath() {
        return 'from';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  declarations: [
    DxoMenuFromComponent
  ],
  exports: [
    DxoMenuFromComponent
  ],
})
export class DxoMenuFromModule { }
